import script from "./LogoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutPage.vue?vue&type=script&setup=true&lang=js"

import "./LogoutPage.vue?vue&type=style&index=0&id=f3367618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3367618"]])

export default __exports__